import { RootPage } from '../page';
import $api from '../../api';
import CompanyUsersView from './usersView';

class SettingsInstallView extends RootPage {
    constructor() {
        super();

        CompanyUsersView(this);

        this.installationType = ko.observable('web');

        this.devMails = ko.observable('');
        this.devMails.isEmpty = ko.pureComputed(() => {
            return this.devMails() === '' || !this.devMails();
        });
    }

    sendCodeSnippet() {
        if (this.devMails.isEmpty()) return;

        TRACK_EVENT('Projects', 'Sending code snippet info to emails', { from: 'settings' });

        this.startSubmitting('devMails');
        $api.projects.sendCodeSnippetInfo(
            { projectCode: auth.project.UniqueCode },
            { targetEmails: this.devMails() },
            (resp) => {
                this.devMails('');
                this.stopSubmitting('devMails');
                this.showToast('Installation instructions sent!');
            }
        );
    }

    onInit() {
        
    }
}

export default SettingsInstallView;